import { useState, useEffect } from 'react';
import { Channel, isRealChannel, isSlackChannel } from '@hud/portal-dtos/channels.dtos';
import useSlackChannels from '../../../hooks/useSlackChannels';
import SetChannelDialog from './SetChannelDialog';
import { SlackChannel } from '@hud/slack-dtos/api';

type SetChannelDialogRendererProps = {
  opened: boolean;
  onClose: () => void;
  onSave: (selectedSlackChannel: SlackChannel | null) => void;
  selectedServices: Channel[];
  editedChannel?: Channel;
  onDelete: (channelId: string) => void;
};

const SetChannelDialogRenderer: React.FC<SetChannelDialogRendererProps> = ({
  opened,
  onClose,
  onSave,
  selectedServices,
  editedChannel,
  onDelete,
}) => {
  const {
    data: slackChannels,
    isLoading: isLoadingChannels,
    refetch: refetchSlackChannels,
  } = useSlackChannels();
  const [selectedSlackChannel, setSelectedSlackChannel] = useState<SlackChannel | null>(
    null,
  );

  useEffect(() => {
    if (isLoadingChannels) {
      return;
    }
    if (isSlackChannel(editedChannel)) {
      const matchingSlackChannel = slackChannels?.channels.find(
        (channel) => channel.id === editedChannel.config.channelId,
      );
      setSelectedSlackChannel(matchingSlackChannel || null);
    }
  }, [editedChannel]);
  return (
    <SetChannelDialog
      opened={opened}
      onClose={onClose}
      onSave={onSave}
      selectedChannels={selectedServices}
      slackChannels={slackChannels?.channels || []}
      isLoadingChannels={isLoadingChannels}
      selectedSlackChannel={selectedSlackChannel}
      onSlackChannelChange={setSelectedSlackChannel}
      onCheckAgainIsMemberOfSlackChannel={() => {
        refetchSlackChannels();
      }}
      onDelete={
        isRealChannel(editedChannel) ? () => onDelete(editedChannel.id) : undefined
      }
    />
  );
};

export default SetChannelDialogRenderer;
